const fontSans =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export function buildAntdTheme({
  primary = "#05557a",
  page = "#eef5f8",
  border = "#c5d7e0",
} = {}) {
  return {
    cssVar: true,
    token: {
      colorPrimary: primary,
      colorSuccess: "#10b981",
      colorWarning: "#f59e0b",
      colorError: "#ef4444",
      colorInfo: primary,
      colorText: "#0f2940",
      colorTextSecondary: "#4f6273",
      colorBorder: border,
      colorBgLayout: page,
      borderRadius: 8,
      fontFamily: fontSans,
      fontSize: 15,
      lineHeight: 1.5,
      fontWeightStrong: 700,
    },
    components: {
      Card: {
        headerFontSize: 16,
        headerFontSizeSM: 16,
        headerHeight: 48,
        headerHeightSM: 44,
      },
      Statistic: {
        titleFontSize: 13,
        contentFontSize: 24,
      },
      Button: {
        fontWeight: 700,
        contentFontSize: 13,
        contentFontSizeLG: 14,
        borderRadius: 8,
        primaryColor: "#ffffff",
        defaultBorderColor: border,
        defaultColor: "#0f2940",
      },
      Tag: {
        fontSize: 12,
      },
      Typography: {
        titleMarginTop: 0,
        titleMarginBottom: 0,
        fontWeightStrong: 700,
      },
    },
  };
}

const antdTheme = buildAntdTheme();

export default antdTheme;
